import './truncated_text.less';

import PropTypes from 'prop-types';

import React, { Component } from 'react';
import classNames from 'classnames';

import Tipsy from 'zoomforth_component_lib/tipsy.jsx';

class TruncatedText extends Component {

  constructor() {
    super();

    this.state = {
      isTruncated: false
    };

    this.renderContent = this.renderContent.bind(this);
  }

  componentDidMount() {
    const el = this.truncatedDivComponent;
    if (el.offsetWidth < el.scrollWidth) {
      this.setState({ isTruncated: true });
    }
  }

  renderContent() {
    const { className, maxWidth, children } = this.props;

    return (
      <div
        ref={(thisDiv)=> { this.truncatedDivComponent = thisDiv; }}
        className={classNames('truncated-text', {}, className)}
        style={{ maxWidth }}
      >

        {children}

      </div>
    );
  }

  render() {
    const { isTruncated } = this.state;
    const {
      children,
      alwaysShowTooltip,
      tooltipContent,
      tooltipPlacement,
      isTooltipEnabled
    } = this.props;

    if (isTooltipEnabled && (isTruncated || alwaysShowTooltip)) {
      return (
        <Tipsy content={tooltipContent || children} placement={tooltipPlacement}>
          {this.renderContent()}
        </Tipsy>
      );
    }
    return this.renderContent();
  }
}

TruncatedText.propTypes = {
  children: PropTypes.node.isRequired,
  tooltipContent: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.node
  ]),
  isTooltipEnabled: PropTypes.bool,
  // In the case where you want to truncate the children but want to show
  // the tooltip regardless, we accomodate that
  alwaysShowTooltip: PropTypes.bool,
  className: PropTypes.string,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tooltipPlacement: PropTypes.string
};

TruncatedText.defaultProps = {
  className: '',
  maxWidth: '90%',
  tooltipPlacement: 'bottom',
  alwaysShowTooltip: false,
  isTooltipEnabled: true
};

export default TruncatedText;
